export const baseUrl = process.env.REACT_APP_BASE_URL;
export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const internalWebUrl = process.env.REACT_APP_INTERNAL_WEB_URL;
